export default __webpack_public_path__ + "static/media/0030.266ca2f9.WAV";